import { render } from "./SmallerCard.vue?vue&type=template&id=b1cfade4"
import script from "./SmallerCard.vue?vue&type=script&lang=js"
export * from "./SmallerCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__